import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles/selection-group.module.css';
import { SelectionGroupContextDispatcher, SelectionGroupContextData } from './selection-group-context';
/**
 * Компонент `<SelectionGroup />` является группой выбора вариантов.
 * Можно использовать выбор одного или множества элементов
 *
 * @example ``` tsx
 *  <SelectionGroup onChange={changeOptionHandler} active={option}>
 <SelectionGroupItem value="id_1">1</SelectionGroupItem>
 <SelectionGroupItem value="id_2">2</SelectionGroupItem>
 <SelectionGroupItem value="id_3">3</SelectionGroupItem>
 </SelectionGroup>
 * ```
 */
export const SelectionGroup = /*#__PURE__*/forwardRef(function SelectionGroup({
  children,
  className = '',
  onChange,
  active,
  extraCheck,
  variant,
  size,
  rounded
}, ref) {
  const selectionGroupRootClass = useMemo(() => clsx(styles.selectionGroup, className), [className]);
  return /*#__PURE__*/React.createElement("div", {
    className: selectionGroupRootClass,
    role: "group",
    ref: ref
  }, /*#__PURE__*/React.createElement(SelectionGroupContextData.Provider, {
    value: {
      extraCheck,
      variant,
      size,
      rounded
    }
  }, /*#__PURE__*/React.createElement(SelectionGroupContextDispatcher.Provider, {
    value: {
      onChangeSelection: onChange,
      active
    }
  }, children)));
});